module.exports = __webpack_public_path__ + "static/media/intro.1ead3bc2.mp3";